import { findParentNode } from "@tiptap/core";

export const getListItemPos = ({ selection }) => {
    const listNode = findParentNode(node => node.type.name === "listItem")(selection);

    if (!listNode) {
        return null;
    }

    return {
        from: listNode.pos,
        to: listNode.pos + listNode.node.nodeSize,
    };
};
